import { useGetUserSession } from '@/shared/hooks/api/auth'

/** True when the signed-in Lex user may mutate org-scoped data (not view-only). */
export function useCanWriteOrgData(): boolean {
  const { data: session } = useGetUserSession()
  if (session == null) {
    return false
  }
  return !session.isReadOnly
}
